import { ProfileData, UserType } from '../../clients';

interface UseProfilePermissionsProps {
  currentSessionUser: ProfileData;
  profileDataToBeEdited?: ProfileData;
}

interface UseProfilePermissionsReturn {
  isEditingOwnProfile: boolean;
  canEditUserTypeAndApps: boolean;
  canEditProfile: boolean;
  canDeleteProfile: boolean;
  canManageProfileState: boolean;
}

export function useProfilePermissions({
  currentSessionUser,
  profileDataToBeEdited,
}: UseProfilePermissionsProps): UseProfilePermissionsReturn {
  const isEditingOwnProfile = currentSessionUser.id === profileDataToBeEdited?.id;

  const canEditUserTypeAndApps = currentSessionUser.userType !== UserType.staff;

  const canEditProfile =
    currentSessionUser.userType === UserType.admin ||
    currentSessionUser.userType === UserType.owner ||
    isEditingOwnProfile;

  const canDeleteProfile =
    (currentSessionUser.userType === UserType.admin || currentSessionUser.userType === UserType.owner) &&
    !!profileDataToBeEdited &&
    !isEditingOwnProfile;

  const canManageProfileState =
    (currentSessionUser.userType === UserType.admin || currentSessionUser.userType === UserType.owner) &&
    !!profileDataToBeEdited &&
    !isEditingOwnProfile;

  return {
    isEditingOwnProfile,
    canEditUserTypeAndApps,
    canEditProfile,
    canDeleteProfile,
    canManageProfileState,
  };
}
